import numeral from "numeral";
import Constants from "./Constants";

export class Numbers {
    public static toShortFormat(n: number) {
        return numeral(n).format(Constants.CurrencyShortFormat);
    }
}
